import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Footer from '../layout/Footer';
import Header from '../layout/Header';
import Default from './Default';

export default class Talents extends Default {

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor() {
    super();
  }

  beforeShow() {
    Header.showOverlay(true, false);
    Header.closeHeader();
    super.beforeShow();
  }

  hide__effect() {
    Footer.hide();
    super.hide__effect();
  }

  afterHide() {
    Header.hideOverlay();
    super.afterHide();
  }
}

ControllerPage._addPage('page-talents', Talents)
